export default __webpack_public_path__ + "static/media/img_1.de7586b5.png";